import React from 'react';
import { LinearProgress, CircularProgress } from '@material-ui/core';

function spinner() {
    return (
        <CircularProgress color="secondary" />
    )
}

export default spinner
